import React, { useState } from "react";
import Icon from "../../Icon/Icon";
import { createLink, getValueFromJson } from "../../../utils";
import { useGlobalValue } from "../../../state/GlobalProvider";
import { Link } from "../..";
import Format from "../../Format";
import styles from "./TopsCard.module.sass";
const TopsCard = props => {
  const {
    data: cData,
    title,
    tabs,
    currencyType
  } = props || {};
  const {
    i18n
  } = useGlobalValue();
  const [selected, setSelected] = useState(0);
  let totalValue = 0;
  let totalPercentage = 0;
  const items = cData && cData[selected] || [];
  const {
    proxy,
    params
  } = useGlobalValue();
  const list = items.map((item, index) => {
    const {
      name,
      value,
      percentage,
      total
    } = item;
    totalValue = total ? total : totalValue + value;
    totalPercentage += percentage;
    const linkTo = createLink(null, proxy, item, params);
    const itemName = `${index + 1} - ${name}`;
    return /*#__PURE__*/React.createElement("div", {
      key: index,
      className: styles["list-item"]
    }, linkTo ? /*#__PURE__*/React.createElement(Link, {
      className: styles["item-link"],
      to: linkTo,
      label: itemName
    }) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h5", null, itemName)), /*#__PURE__*/React.createElement("small", null, currencyType ? /*#__PURE__*/React.createElement(Format, {
      value: value,
      compact: "short",
      currency: getValueFromJson(currencyType, "currency"),
      locale: getValueFromJson(currencyType, "localeCurrency")
    }) : /*#__PURE__*/React.createElement(Format, {
      value: value,
      compact: "short"
    })), /*#__PURE__*/React.createElement("h5", null, (percentage || 0).toFixed(2), "%"));
  });
  return /*#__PURE__*/React.createElement("div", {
    className: `${styles["root"]} top-card-to-include`
  }, /*#__PURE__*/React.createElement("div", {
    className: `widget-title ${styles["title-container"]}`
  }, /*#__PURE__*/React.createElement(Icon, {
    className: styles["icon"],
    name: "list_alt"
  }), /*#__PURE__*/React.createElement("h5", {
    className: styles["title"]
  }, title), /*#__PURE__*/React.createElement("div", {
    className: styles["tabs"]
  }, (tabs || []).map((tabName, index) => /*#__PURE__*/React.createElement("div", {
    key: index,
    className: `${styles["tab"]} ${selected === index ? styles["is-selected"] : ""}`,
    onClick: () => {
      setSelected(index);
    }
  }, /*#__PURE__*/React.createElement("small", null, i18n(tabName)))))), /*#__PURE__*/React.createElement("div", {
    className: styles['totals-header']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['totals-header-list']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['list-item']
  }, /*#__PURE__*/React.createElement("h5", null, "Totals"), /*#__PURE__*/React.createElement("h5", null, /*#__PURE__*/React.createElement(Format, {
    value: totalValue,
    compact: "short",
    currency: getValueFromJson(currencyType, "currency"),
    locale: getValueFromJson(currencyType, "localeCurrency")
  })), /*#__PURE__*/React.createElement("h5", null, (totalPercentage || 0).toFixed(2), "%")))), /*#__PURE__*/React.createElement("div", {
    className: styles['header']
  }, /*#__PURE__*/React.createElement("h5", {
    className: styles['item']
  }, "Sales Name"), /*#__PURE__*/React.createElement("h5", {
    className: styles['item']
  }, "Financial Amount"), /*#__PURE__*/React.createElement("h5", {
    className: styles['item']
  }, "Percentage / 100%")), /*#__PURE__*/React.createElement("div", {
    className: styles["list"]
  }, list));
};
export default TopsCard;